import { forwardRef, Ref } from "react";
import { useTranslation } from "react-i18next";

import { Color } from "utils/theme";
import { Captain } from "types/captains";
import { CaptainCard } from "./captain-card";

type CaptainListProps = {
  captains: Captain[];
  value: Captain | null;
  onValueChange: (captain: Captain | null) => void;
};

export const CaptainList = forwardRef(
  (
    { captains, value, onValueChange }: CaptainListProps,
    ref: Ref<HTMLDivElement> | undefined
  ) => {
    const { t } = useTranslation();

    if (captains.length === 0) {
      return (
        <p
          className="w-full h-[80vh] text-xl flex items-center justify-center p-3"
          style={{ color: Color.Primary[400] }}
        >
          {t("captain_selection.no_captains_available")}
        </p>
      );
    }

    return (
      <div ref={ref} className="p-2 pb-6">
        {captains
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((captain) => {
            const isSelected = value?.id === captain.id;

            return (
              <div
                key={captain.id}
                style={{ borderColor: Color.Primary[700] }}
                className="border-b"
              >
                <CaptainCard
                  key={captain.id}
                  isSelected={isSelected}
                  onClick={() => onValueChange(isSelected ? null : captain)}
                  name={captain.name}
                />
              </div>
            );
          })}
      </div>
    );
  }
);
